import { baseApi } from './baseApi';

/**
 * Zendesk Sell Tasks API endpoints
 * Handles fetching tasks from Zendesk Sell via our backend proxy
 */
export const tasksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /zendesk-tasks - Fetch tasks with pagination, search, filtering, and sorting
    getTasks: builder.query({
      query: ({ page = 1, limit = 10, search, status, owner, taskable_type, date_from, date_to, sort_by, sort_direction } = {}) => {
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('limit', limit);
        if (search) params.append('search', search);
        if (status) params.append('status', status);
        if (owner) params.append('owner', owner);
        if (taskable_type) params.append('taskable_type', taskable_type);
        if (date_from) params.append('date_from', date_from);
        if (date_to) params.append('date_to', date_to);
        if (sort_by) params.append('sort_by', sort_by);
        if (sort_direction) params.append('sort_direction', sort_direction);
        return `/zendesk-tasks?${params.toString()}`;
      },
      providesTags: (result) =>
        result?.tasks
          ? [
              ...result.tasks.map(({ id }) => ({ type: 'Task', id })),
              { type: 'Task', id: 'LIST' },
            ]
          : [{ type: 'Task', id: 'LIST' }],
      // Transform the response to ensure consistent data structure
      transformResponse: (response) => {
        const tasks = response?.tasks || [];
        return {
          tasks: tasks.map((task) => ({
            ...task,
            // Determine status based on done_at
            status: task.done_at ? 'completed' : 'pending',
          })),
          pagination: response?.pagination || {
            current_page: 1,
            per_page: tasks.length,
            total: tasks.length,
            total_pages: 1
          },
          meta: response?.meta || { total_count: tasks.length },
        };
      },
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetTasksQuery,
} = tasksApi;

